import { render, staticRenderFns } from "./CoinSettings.vue?vue&type=template&id=a40b724a&scoped=true&"
import script from "./CoinSettings.vue?vue&type=script&lang=ts&"
export * from "./CoinSettings.vue?vue&type=script&lang=ts&"
import style0 from "./CoinSettings.vue?vue&type=style&index=0&id=a40b724a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40b724a",
  null
  
)

export default component.exports